import { Box, Link as MuiLink } from '@mui/material';
import Navbar from './Navbar';
import Footer from './Footer';
import { useEffect } from 'react';
import FeedbackModal from '../feedback/FeedbackModal';
import { FeedbackModalProvider, useFeedbackModal } from '../../contexts/FeedbackModalContext';

function FeedbackDeepLinkHandler() {
    const { openFeedbackModal } = useFeedbackModal();

    useEffect(() => {
        const checkDeepLink = () => {
            if (typeof window === 'undefined') return;
            try {
                const params = new URLSearchParams(window.location.search);
                const reportIssue = params.get('reportIssue');
                const report = params.get('report');
                const feedback = params.get('feedback');

                if (reportIssue === 'true' || reportIssue === '1' || report === 'bug' || feedback === 'bug') {
                    openFeedbackModal('bug');

                    params.delete('reportIssue');
                    if (report === 'bug') params.delete('report');
                    if (feedback === 'bug') params.delete('feedback');
                    const remaining = params.toString();
                    const newPath = window.location.pathname + (remaining ? `?${remaining}` : '') + window.location.hash;
                    window.history.replaceState(null, '', newPath);
                }
            } catch {
                // ignore
            }
        };

        checkDeepLink();
        window.addEventListener('popstate', checkDeepLink);
        return () => window.removeEventListener('popstate', checkDeepLink);
    }, [openFeedbackModal]);

    return null;
}

function Layout({ children }) {
    return (
        <FeedbackModalProvider>
            <FeedbackDeepLinkHandler />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '100vh',
                    width: '100%',
                    maxWidth: '100%',
                    overflowX: 'clip',
                }}
            >
                <MuiLink
                    href="#main-content"
                    sx={{
                        position: 'absolute',
                        width: '1px',
                        height: '1px',
                        padding: 0,
                        margin: '-1px',
                        overflow: 'hidden',
                        clip: 'rect(0, 0, 0, 0)',
                        whiteSpace: 'nowrap',
                        border: 0,
                        zIndex: 9999,
                        '&:focus': {
                            position: 'fixed',
                            top: 12,
                            left: 12,
                            width: 'auto',
                            height: 'auto',
                            clip: 'auto',
                            whiteSpace: 'normal',
                            bgcolor: 'primary.main',
                            color: 'primary.contrastText',
                            px: 2,
                            py: 1,
                            borderRadius: 1,
                            boxShadow: 3,
                            fontWeight: 'bold',
                            outline: '2px solid white',
                            textDecoration: 'none',
                        },
                    }}
                >
                    Skip to main content
                </MuiLink>
                <Navbar />
                <Box
                    component="main"
                    id="main-content"
                    tabIndex="-1"
                    sx={{ flexGrow: 1, width: '100%', maxWidth: '100%', overflowX: 'clip', position: 'relative', outline: 'none' }}
                >
                    {children}
                </Box>
                <Footer />
                <FeedbackModal />
            </Box>
        </FeedbackModalProvider>
    );
}

export default Layout;
